import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import * as React from 'react';
import styles from '../styles.module.scss';
import { BothDirectionIcon } from './BothDirectionIcon';
import { OutboundDirectionIcon } from './OutboundDirectionIcon';
export const DirectionIcon = ({ size = 16, direction, className, }) => {
    const classNames = classnames(styles.directionIcon, className);
    const wrapperStyle = { width: size, height: size };
    switch (direction) {
        case 'outbound':
            return (_jsx("div", Object.assign({ className: classNames, style: wrapperStyle }, { children: _jsx(OutboundDirectionIcon, {}) })));
        case 'internal':
            return (_jsx("div", Object.assign({ className: classNames, style: wrapperStyle }, { children: _jsx(BothDirectionIcon, {}) })));
        default:
            return null;
    }
};
